module.exports = __webpack_public_path__ + "img/well-done.6715f123.jpg";